export default "__VITE_ASSET__BIMigsv1__"